export function mergeDictionaries(staticData: any, dynamicData: any) {
  const result = JSON.parse(JSON.stringify(staticData));
  for (const key in dynamicData) {
    const parts = key.split('.');
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current[parts[i]]) current[parts[i]] = {};
      current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = dynamicData[key];
  }
  return result;
}
